import { hide, show, toggle } from "slidetoggle";

export const slideToggleDefaults = {
  miliseconds: 300,
  transitionFunction: 'linear',
};
export const slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
export const slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};
export const slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};
export const isHidden = (el) => el.offsetParent === null;

export const SlideToggleContainer = () => ({
  "@slideToggle"() {
    this.slideOpen = ! this.slideOpen;
  },
  "@slideUp"() {
    this.slideOpen = true;
  },
  "@slideDown"() {
    this.slideOpen = false;
  },
  "x-init"() {
    const slideOpts = {
      miliseconds: this.$data.duration || 300,
    };

    this.$watch('slideOpen', (openValue) => {
      if (openValue) slideDown(this.$el, slideOpts);
      else slideUp(this.$el);
    });
    this.slideOpen = !isHidden(this.$el, slideOpts);
  }
});

window.Alpine?.bind('SlideToggleContainer', SlideToggleContainer);
